import { render } from "./UserCoin.vue?vue&type=template&id=b1d82d5e&ts=true"
import script from "./UserCoin.vue?vue&type=script&lang=ts"
export * from "./UserCoin.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__